export default __webpack_public_path__ + "static/media/CV.1807f845.pdf";